import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import Index from "../views/index.vue";

Vue.use(VueRouter);
export default new VueRouter({
  mode: 'history',
  base: '/home',
  routes: [
    {
      path: '/index',
      // alias: '/',
      component: Index,
      meta: {
        pageId: 'AdminPcHome',
        pageName: '管理员PC-分公司首页',
        pageLevel: '1'
      }
    },
    {
      path: '/appraisal/my-okr',
      component: () => import('../views/appraisal/my-okr.vue'),
      meta: {
        pageId: 'AdminPcAppraisalOkrIndex',
        pageName: '管理员PC-分子公司-我的OKR',
        pageLevel: '1'
      },
    },
    {
      path: '/appraisal/okr-list',
      component: () => import('../views/appraisal/okr-list.vue'),
      meta: {
        pageId: 'AdminPcHomeAppraisalOkrList',
        pageName: '管理员PC-分子公司-OKR列表',
        pageLevel: '1'
      }
    },
    {
      path: '/copilot',
      component: () => import('../views/copilot/copilot.vue'),
      meta: {
        pageId: 'AdminPcHomeCopilot',
        pageName: '管理员PC-分子公司-AI小薪',
        pageLevel: '1'
      }
    },
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/.html',
      redirect: '/index'
    },
    {
      path: '/list.html',
      redirect: '/index'
    },
    {
      path: '*',
      component: () => import('components/not-found/index.vue')
    },
  ]
})